import ApproveRejectPage from "./ApproveRejectPage";
export default ApproveRejectPage;